var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCmImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 95,
    viewBox: "0 0 111 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2333 70.75H1V88C1 91.3137 3.68629 94 7 94H28.2333V70.75Z",
    fill: "#FAFF00",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4969 70.75H28.2637V94H55.4969V70.75Z",
    fill: "#06345A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7518 70.75H55.5186V94H82.7518V70.75Z",
    fill: "#810100",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.02 70.75H82.7871V94H104.02C107.334 94 110.02 91.3137 110.02 88V70.75Z",
    fill: "#810100",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2333 47.5H1V70.75H28.2333V47.5Z",
    fill: "#ADFF00",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4969 47.5H28.2637V70.75H55.4969V47.5Z",
    fill: "#FAFF00",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7518 47.5H55.5186V70.75H82.7518V47.5Z",
    fill: "#06345A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.02 47.5H82.7871V70.75H110.02V47.5Z",
    fill: "#810100",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2333 24.25H1V47.5H28.2333V24.25Z",
    fill: "#0DE671",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4969 24.25H28.2637V47.5H55.4969V24.25Z",
    fill: "#ADFF00",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7518 24.25H55.5186V47.5H82.7518V24.25Z",
    fill: "#FAFF00",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.02 24.25H82.7871V47.5H110.02V24.25Z",
    fill: "#06345A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2333 1H7C3.68629 1 1 3.68629 1 7V24.25H28.2333V1Z",
    fill: "#0DE671",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4969 1H28.2637V24.25H55.4969V1Z",
    fill: "#0DE671",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7518 1H55.5186V24.25H82.7518V1Z",
    fill: "#ADFF00",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.02 1H82.7871V24.25H110.02V7C110.02 3.68629 107.334 1 104.02 1Z",
    fill: "#FAFF00",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCmImage);
export default __webpack_public_path__ + "static/media/default-cm-image.f36ab900082376464e8860c10182ad59.svg";
export { ForwardRef as ReactComponent };